import { Injectable, computed, inject } from '@angular/core';

import { FEATURE_FLAGS } from 'app/app-config/configurations/splitIO-config';
import { SplitIOService } from 'app/shared/services/splitIO/splitIO.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagSignalsService {
  private splitIOService = inject(SplitIOService);

  readonly isPassiveFullstoryTrackingEnabled = computed(() => this.splitIOService.getTreatment(FEATURE_FLAGS.PASSIVE_FULLSTORY_EVENT_TRACKING) === 'on');
  readonly isAutoAdvanceEnabled = computed(() => this.splitIOService.getTreatment(FEATURE_FLAGS.QT_1116_auto_progress_forms) === 'on');
}
